import { GA_CONFIG } from '../config/analytics';

// Google Analytics configuration
export const GA_TRACKING_ID = GA_CONFIG.TRACKING_ID;

// Initialize Google Analytics
export const initGA = () => {
  if (GA_TRACKING_ID && window.gtag) {
    window.gtag('config', GA_TRACKING_ID, {
      page_title: document.title,
      page_location: window.location.href,
    });
  }
};

// Track page views
export const trackPageView = (url) => {
  if (GA_TRACKING_ID && window.gtag) {
    window.gtag('config', GA_TRACKING_ID, {
      page_path: url,
    });
  }
};

// Track custom events
export const trackEvent = (action, category, label, value) => {
  if (GA_TRACKING_ID && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Track button clicks
export const trackButtonClick = (buttonName, location) => {
  trackEvent('click', 'button', `${buttonName}_${location}`);
};

// Track form submissions
export const trackFormSubmission = (formName) => {
  trackEvent('submit', 'form', formName);
};

// Track scroll depth
export const trackScrollDepth = (depth) => {
  trackEvent('scroll', 'engagement', 'scroll_depth', depth);
};

// Track time on page
export const trackTimeOnPage = (timeInSeconds) => {
  trackEvent('timing_complete', 'engagement', 'time_on_page', timeInSeconds);
};
